
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.37.231a1.58 1.58 0 00-1.611.09 1.667 1.667 0 00-.712 1.42.768.768 0 000 .015c.005.088.018.175.038.26L1.702 9.17a.768.768 0 00.75.598H7.29A.767.767 0 008.058 9a.767.767 0 00-.768-.767H3.065L1.586 1.69c.003-.058.024-.089.042-.101.02-.014-.011-.02.02-.002L15.556 9 1.648 16.414c-.03.016 0 .01-.02-.002-.017-.012-.035-.043-.04-.094l1.196-4.387a.767.767 0 00-.54-.943.767.767 0 00-.941.54L.105 15.913c0 .003 0 .006-.002.008l-.002.01c-.032.114-.05.23-.054.348a.768.768 0 000 .02 1.66 1.66 0 00.728 1.387c.44.295 1.071.363 1.597.082l15.175-8.092a.768.768 0 000-1.353z"}})])
          )
        }
      }
    